import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_ALL_CLICK,
  SERVICE_LINKS_CSW,
  type TrackingEvent,
} from 'shared/experiments/consts'
import { event as e } from 'shared/experiments/utils/event'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'
import store, { subscribe } from 'shared/store'
import { INIT_XSELL_MOBILE_COMPACT_SLIDER } from 'shared/store/ducks/events'

const bindSliderTracking = () => {
  const sliderTrackingDefs: TrackingEvent[] = [
    {
      selector: '.o-ServiceLinksContainer__column .o-ProductSliderItem',
      event: 'click',
      trackingEvent: CSW_PRODUCT_CLICK,
    },
    {
      selector: '.o-ServiceLinksContainer__column .o-SliderHorizontal__nav',
      event: 'click',
      trackingEvent: CSW_ARROW_CLICK,
    },
    {
      selector:
        '.o-ServiceLinksContainer__column .o-SliderHorizontal__header a',
      event: 'click',
      trackingEvent: CSW_SHOW_ALL_CLICK,
    },
  ]

  // Bind events after the slider pops in layout
  subscribe.after(INIT_XSELL_MOBILE_COMPACT_SLIDER, () =>
    requestAnimationFrame(() => bindTrackingEvents(sliderTrackingDefs))
  )
}

const bindServiceLinks = () => {
  bindTrackingEvents([
    {
      selector: '.o-ServiceLinks .o-IconLinksList__Link',
      event: 'click',
      trackingEvent: e`Click on service link`,
    },
  ])
}

export default () => {
  const {
    pageProperties: { experiments },
  } = store.getState().publicRuntimeConfig
  const activeServiceLink = getExperiment(SERVICE_LINKS_CSW, experiments)

  // Events tracking is enabled for all variations, including default
  if (!activeServiceLink.isEnabled) {
    return
  }

  bindServiceLinks()
  bindSliderTracking()
}
